import {
    SetEnableBulkCompletePhaseAction,
    SetProjectDetailsAction,
    SetWorkflowDefinitionsAction,
} from "../../interfaces/store/actions/project";
import {ProjectState} from "../../interfaces/store/reducers/projectState";
import {
    SET_ENABLE_BULK_COMPLETE,
    SET_PROJECT_DETAILS,
    SET_WORKFLOW_DEFINITIONS,
} from "../actions/availableActions";

const initialState: ProjectState = {
    projectDetails: null,
    workflowDefinitions: [],
    enableBulkCompletePhaseAction: false,
};

type AvailableActions = SetProjectDetailsAction | SetWorkflowDefinitionsAction | SetEnableBulkCompletePhaseAction;

const projectReducer = (state: ProjectState = initialState, action: AvailableActions): ProjectState => {
    switch (action.type) {
        case SET_PROJECT_DETAILS:
            return {...state, projectDetails: action.payload};
        case SET_WORKFLOW_DEFINITIONS:
            return {...state, workflowDefinitions: action.payload};
        case SET_ENABLE_BULK_COMPLETE:
            return {
                ...state,
                enableBulkCompletePhaseAction: action.payload,
            };
        default:
            return state;
    }
};

export default projectReducer;
